import React from "react";

const GoogleDriveIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2773_1247)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.02404 32.76L4.78809 35.8069C5.15465 36.4484 5.68152 36.9525 6.30011 37.319C8.07197 35.07 9.30508 33.3441 10.0001 32.1414C10.7052 30.921 11.5719 29.0118 12.6002 26.4141C9.82898 26.0493 7.729 25.8669 6.30026 25.8669C4.92887 25.8669 2.82888 26.0493 0 26.4141C0 27.1243 0.18328 27.8344 0.549839 28.476L3.02404 32.76Z",
  fill: "#0066DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.6995 37.319C34.3182 36.9525 34.8451 36.4484 35.2115 35.807L35.9446 34.547L39.4499 28.476C39.8097 27.8483 39.9992 27.1376 39.9996 26.4141C37.1543 26.0493 35.0582 25.8669 33.7111 25.8669C32.2633 25.8669 30.167 26.0493 27.4224 26.4141C28.4384 29.026 29.2938 30.9352 29.9883 32.1414C30.6887 33.3584 31.9258 35.0842 33.6995 37.319V37.319Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9996 13.5847C22.0496 11.109 23.4624 9.19976 24.2378 7.85743C24.8623 6.7765 25.5497 5.05058 26.2997 2.67981C25.6811 2.31325 24.9709 2.12997 24.2378 2.12997H15.7613C15.0282 2.12997 14.3182 2.33622 13.6995 2.67981C14.6535 5.39886 15.4632 7.334 16.1282 8.48508C16.8632 9.75726 18.1536 11.4571 19.9996 13.5847Z",
  fill: "#00832D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4001 26.4141H12.6005L6.30054 37.319C6.91897 37.6856 7.62912 37.8689 8.36224 37.8689H31.6383C32.3714 37.8689 33.0817 37.6626 33.7002 37.3189L27.4001 26.4141Z",
  fill: "#2684FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 13.5847L13.7 2.67996C13.0813 3.04652 12.5544 3.55042 12.1879 4.19198L0.549839 24.3523C0.190018 24.9799 0.000475383 25.6907 0 26.4142H12.6002L20 13.5847Z",
  fill: "#00AC47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.6314 14.2721L27.8122 4.19183C27.4458 3.55027 26.9188 3.04637 26.3002 2.67981L20.0002 13.5847L27.3999 26.4142H39.9773C39.9773 25.7038 39.794 24.9939 39.4274 24.3523L33.6314 14.2721Z",
  fill: "#FFBA00"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2773_1247"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 35.7389,
  fill: "white",
  transform: "translate(0 2.13)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleDriveIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;